Send an email
<i-feather
  name="mail"
  class="small-icon position-relative"
  style="top: -1px;"
></i-feather>
